import React from 'react';
import { motion } from 'framer-motion';

function PracticeSession() {
  return (
    <section className="session-section section-wrap" id="session">
      <div className="section-heading session-heading">
        <span className="eyebrow">Your practice starts here</span>
        <h2>Start your session</h2>
        <p className="session-note">
          Use a quiet space and a computer or phone with a microphone. Please don’t use real student names or private details during practice.
        </p>
      </div>
      <motion.div
        className="session-card"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.5 }}
      >
        <iframe
          src="https://events-appsumo.app.toughtongueai.com/embed/6adee08d109c213e4845519d?skipPrecheck=true"
          width="100%"
          height="709px"
          frameborder="0"
          allow="microphone; camera; display-capture"
        ></iframe>
      </motion.div>
      <p className="trouble-note">
        <span aria-hidden="true">↗</span> Trouble connecting? Check that your browser has microphone access, then refresh the page.
      </p>
    </section>
  );
}

export default PracticeSession;
